import {mainSlider, serviceSlider, insuranceSlider, insuranceSliderCom, insuranceSliderRef, insuranceSliderDen, blogSlider} from '../../components/sliders'

const init = () => {
  mainSlider()
  serviceSlider()
  insuranceSlider()
  insuranceSliderCom()
  insuranceSliderRef()
  insuranceSliderDen()
  blogSlider()
}

export default init
